import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import CrossIcon from '../../../assets/cross-icon-new.svg';
import { ROUTES } from '../../router';

import styles from '../../styles/views/components/InfoBox.module.scss';

const InfoBox = ({
  isShown, text, wrapperExtraStyles, onClose, children,
}) => {
  const [isInfoBoxShown, setIsInfoBoxShown] = useState(false);

  useEffect(() => {
    setIsInfoBoxShown(isShown);
  }, [isShown]);

  const closeInfoBox = useCallback(() => {
    onClose();
    setIsInfoBoxShown(false);
  }, [onClose]);

  return isInfoBoxShown ? (
    <div className={styles.wrapper} style={wrapperExtraStyles}>
      <div className={styles.text}>
        {children || `${t('components.reachedMaximum', { ns: i18next.Namespace.COMMON, items: text })} `}
        <Link to={ROUTES.projects.upgrades.general.url} className={`${styles.text} ${styles.link}`}>{t('components.customiseYourPackage', { ns: i18next.Namespace.COMMON })}</Link>
      </div>
      <div className={styles.iconWrapper} onClick={closeInfoBox}>
        <CrossIcon />
      </div>
    </div>
  ) : null;
};

InfoBox.propTypes = {
  isShown: PropTypes.bool.isRequired,
  text: PropTypes.string,
  children: PropTypes.node,
  onClose: PropTypes.func,
  wrapperExtraStyles: PropTypes.instanceOf(Object),
};

InfoBox.defaultProps = {
  text: '',
  children: null,
  wrapperExtraStyles: null,
  onClose: () => {},
};

export default InfoBox;
